import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import './CookieConsent.css';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [analyticsEnabled, setAnalyticsEnabled] = useState(true);

  useEffect(() => {
    const consent = Cookies.get('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    } else if (consent === 'accepted-analytics') {
      loadGoogleAnalytics();
    }
  }, []);

  const loadGoogleAnalytics = () => {
    // load skrypt GA4
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=G-57CJFJG08S`;
    document.head.appendChild(script);

    //  inicjalizacja GA4
    window.dataLayer = window.dataLayer || [];
    window.gtag =
      window.gtag ||
      function () {
        window.dataLayer.push(arguments);
      };

    window.gtag('js', new Date());
    window.gtag('config', 'G-57CJFJG08S', { anonymize_ip: true });
  };

  const acceptAll = () => {
    Cookies.set('cookieConsent', 'accepted-analytics', { expires: 365 });
    setShowBanner(false);
    loadGoogleAnalytics();
  };

  const rejectAll = () => {
    Cookies.set('cookieConsent', 'rejected', { expires: 365 });
    setShowBanner(false);
  };

  const saveSettings = () => {
    if (analyticsEnabled) {
      Cookies.set('cookieConsent', 'accepted-analytics', { expires: 365 });
      loadGoogleAnalytics();
    } else {
      Cookies.set('cookieConsent', 'accepted-necessary', { expires: 365 });
    }
    setShowSettings(false);
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <>
      <div className="cookie-banner">
        <p>
          Ta strona używa niezbędnych cookies do działania oraz analitycznych
          (Google Analytics) do zbierania anonimowych statystyk (przechowywane
          do 2 lat).{' '}
          <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
            Więcej w Polityce prywatności
          </a>
          .
        </p>

        <div className="cookie-buttons">
          <button
            className="cookie-btn settings"
            onClick={() => setShowSettings(true)}
          >
            Ustawienia
          </button>
          <button className="cookie-btn reject" onClick={rejectAll}>
            Odrzuć wszystkie
          </button>
          <button className="cookie-btn accept" onClick={acceptAll}>
            Akceptuj wszystkie
          </button>
        </div>
      </div>

      {/* Modal ustawień */}
      {showSettings && (
        <div className="cookie-modal-overlay">
          <div className="cookie-modal">
            <h2>Ustawienia cookies</h2>

            <div className="cookie-option">
              <strong>Niezbędne cookies</strong>
              <p>Do prawidłowego działania strony (nie można wyłączyć).</p>
              <span>Zawsze włączone</span>
            </div>

            <div className="cookie-option">
              <strong>Cookies analityczne (Google Analytics)</strong>
              <p>
                Pomagają zrozumieć, jak użytkownicy korzystają ze strony
                (anonimowo).
              </p>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={analyticsEnabled}
                  onChange={(e) => setAnalyticsEnabled(e.target.checked)}
                />
                <span className="slider"></span>
              </label>
            </div>

            <div className="cookie-modal-buttons">
              <button
                className="cookie-btn cancel"
                onClick={() => setShowSettings(false)}
              >
                Anuluj
              </button>
              <button className="cookie-btn save" onClick={saveSettings}>
                Zapisz wybory
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CookieConsent;
